export default "__VITE_ASSET__n6K1aK7L__"